import { Card, CardBody, CardTitle, CardSubtitle, ListGroup, ListGroupItem, CardText, Button } from "reactstrap";

const LocationCard = ({ location, podiums }) => {
    if (!location) {
        return null;
    }
    return (
        <Card
            color="light"
            body
            className="text-center">
            <CardBody>
                {/* name, regionId, address, city, state, zipCode, phone  */}
                <CardTitle>{location.name}</CardTitle>
                <CardSubtitle></CardSubtitle>
                <ListGroup>
                    <ListGroupItem>{location.regionId}</ListGroupItem>
                    <ListGroupItem>{location.address}</ListGroupItem>
                    <ListGroupItem>{location.city}</ListGroupItem>
                    <ListGroupItem>{location.state}</ListGroupItem>
                    <ListGroupItem>{location.zipCode}</ListGroupItem>
                    <ListGroupItem>{location.phone}</ListGroupItem>
                    {podiums && podiums.length > 0 ? (
                        <ListGroupItem>
                            <CardText>Podiums:</CardText>
                            {podiums.map((podium) => (
                                <Button
                                    key={podium.id}
                                    color="primary"
                                    className="m-1"
                                    href={`/podiums/id/${podium.id}`}>
                                    {podium.name}
                                </Button>
                            ))}
                        </ListGroupItem>
                    ) : (
                        <ListGroupItem>No podiums assigned</ListGroupItem>
                    )}
                </ListGroup>
            </CardBody>
        </Card>
    );
};

export default LocationCard;
